export function ArrowLeft() {
	return <span className="icon-new icon-chevron-left-grey icon-24 " />;
}

export default ArrowLeft;
